const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.97282 8.9615C7.97282 9.26879 7.87646 9.50381 7.68376 9.66657C7.49235 9.82934 7.21956 9.91072 6.8654 9.91072H6.60563V10.9263H6.00016V8.07087H6.91227C7.25863 8.07087 7.52165 8.14574 7.70133 8.29548C7.88232 8.44392 7.97282 8.66592 7.97282 8.9615ZM6.60563 9.41462H6.80485C6.99105 9.41462 7.13037 9.37816 7.22282 9.30525C7.31527 9.23103 7.36149 9.12361 7.36149 8.98298C7.36149 8.84105 7.32243 8.73624 7.2443 8.66853C7.16748 8.60082 7.04639 8.56697 6.88102 8.56697H6.60563V9.41462Z",
  fill: "#1E3F6B"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.4845 8.9615C10.4845 9.26879 10.3882 9.50381 10.1955 9.66657C10.0041 9.82934 9.73128 9.91072 9.37712 9.91072H9.11735V10.9263H8.51188V8.07087H9.42399C9.77034 8.07087 10.0334 8.14574 10.2131 8.29548C10.394 8.44392 10.4845 8.66592 10.4845 8.9615ZM9.11735 9.41462H9.31657C9.50277 9.41462 9.64209 9.37816 9.73454 9.30525C9.82699 9.23103 9.87321 9.12361 9.87321 8.98298C9.87321 8.84105 9.83415 8.73624 9.75602 8.66853C9.6792 8.60082 9.5581 8.56697 9.39274 8.56697H9.11735V9.41462Z",
  fill: "#1E3F6B"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M11.5197 10.9263H12.1252V8.57478H12.9006V8.07087H10.7443V8.57478H11.5197V10.9263Z",
  fill: "#1E3F6B"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.2633 1.55981L12.8635 4.30947C12.9512 4.40231 13.0002 4.52523 13.0002 4.65301V6.16634H14.1668C14.443 6.16634 14.6668 6.3902 14.6668 6.66634V12.333C14.6668 12.6091 14.443 12.833 14.1668 12.833H13.0002V13.4997C13.0002 13.8091 12.8772 14.1058 12.6585 14.3246C12.4397 14.5434 12.1429 14.6663 11.8335 14.6663H2.50016C2.19074 14.6663 1.894 14.5434 1.6752 14.3246C1.45641 14.1058 1.3335 13.8091 1.3335 13.4997V2.49967C1.3335 2.19026 1.45641 1.89351 1.6752 1.67472C1.894 1.45592 2.19074 1.33301 2.50016 1.33301H9.8335C9.93667 1.33301 10.0364 1.36489 10.1197 1.42302C10.1762 1.45862 10.2251 1.50522 10.2633 1.55981ZM2.38231 2.38182C2.41357 2.35057 2.45596 2.33301 2.50016 2.33301H9.3535V4.65301C9.3535 4.92915 9.57735 5.15301 9.8535 5.15301H12.0002V6.16634H4.66683C4.39069 6.16634 4.16683 6.3902 4.16683 6.66634V12.333C4.16683 12.6091 4.39069 12.833 4.66683 12.833H12.0002V13.4997C12.0002 13.5439 11.9826 13.5863 11.9513 13.6175C11.9201 13.6488 11.8777 13.6663 11.8335 13.6663H2.50016C2.45596 13.6663 2.41357 13.6488 2.38231 13.6175C2.35106 13.5863 2.3335 13.5439 2.3335 13.4997V2.49967C2.3335 2.45547 2.35106 2.41308 2.38231 2.38182ZM11.3392 4.15301L10.3535 3.11063V4.15301H11.3392ZM5.16683 7.16634V11.833H13.6668V7.16634H5.16683Z",
  fill: "#1E3F6B"
});

const SvgPpt = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPpt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ppt.987ad321.svg";
export { ForwardRef as ReactComponent };